import { FC } from 'react';

type Props = {
    className?: string;
};

const CheckmarkCircle_02_Icon: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="#2B2B2B"
            className={className}
        >
            <path
                d="M17.9962 9.99993C17.9962 5.58162 14.4145 1.99987 9.99616 1.99987C5.57785 1.99987 1.99609 5.58162 1.99609 9.99993C1.99609 14.4182 5.57785 18 9.99616 18C14.4145 18 17.9962 14.4182 17.9962 9.99993Z"
                stroke="inherit"
                strokeWidth="1.25"
            />
            <path
                d="M6.79688 10.4001L8.79689 12.4001L13.1969 7.6001"
                stroke="inherit"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CheckmarkCircle_02_Icon;
